import React, {useState, useEffect} from 'react'
import {KTIcon} from '../../../../_metronic/helpers'
import {Rol} from '../core/models'

type Props = {
  selectedRoles: number[]
  availableRoles: Rol[]
  loading: boolean
  onChange: (roleIds: number[]) => void
}

const RolesSelector: React.FC<Props> = ({selectedRoles, availableRoles, loading, onChange}) => {
  const [rolesCache, setRolesCache] = useState<Map<number, Rol>>(new Map())

  // Actualizar el cache con los nuevos roles disponibles
  useEffect(() => {
    setRolesCache((prevCache) => {
      const newCache = new Map(prevCache)
      availableRoles.forEach((rol) => {
        if (!newCache.has(rol.id)) {
          newCache.set(rol.id, rol)
        }
      })
      return newCache
    })
  }, [availableRoles])

  const handleSelectRole = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const roleId = parseInt(e.target.value)
    if (roleId && !selectedRoles.includes(roleId)) {
      onChange([...selectedRoles, roleId])
      e.target.value = '' // Resetear el select
    }
  }

  const handleRemoveRole = (roleId: number) => {
    onChange(selectedRoles.filter((id) => id !== roleId))
  }

  // Usar el cache para obtener los roles seleccionados, así siempre se muestran
  const selectedRolesData = selectedRoles
    .map((id) => rolesCache.get(id))
    .filter((rol): rol is Rol => rol !== undefined)

  // Roles disponibles que no están seleccionados
  const availableRolesNotSelected = availableRoles.filter((rol) => !selectedRoles.includes(rol.id))

  return (
    <div className='mb-5'>
      <label className='fw-bold fs-6 mb-4'>
        <KTIcon iconName='abstract-26' className='fs-3 me-2' />
        Roles
      </label>

      {/* Roles Seleccionados */}
      <div className='d-flex flex-wrap gap-2 mb-3'>
        {selectedRolesData.length > 0 ? (
          selectedRolesData.map((rol) => (
            <span key={rol.id} className='badge badge-light-primary badge-lg'>
              <span className='me-2'>{rol.nombre}</span>
              <button
                type='button'
                className='btn btn-icon btn-sm btn-active-light-primary'
                onClick={() => handleRemoveRole(rol.id)}
                style={{padding: 0, width: '16px', height: '16px'}}
              >
                <KTIcon iconName='cross' className='fs-5' />
              </button>
            </span>
          ))
        ) : (
          <span className='text-muted fs-7'>No hay roles seleccionados</span>
        )}
      </div>

      {/* Dropdown de Roles */}
      <select
        className='form-select form-select-solid'
        onChange={handleSelectRole}
        disabled={loading || availableRolesNotSelected.length === 0}
      >
        <option value=''>Seleccionar un rol para agregar...</option>
        {availableRolesNotSelected.map((rol) => (
          <option key={rol.id} value={rol.id}>
            {rol.nombre}
          </option>
        ))}
      </select>

      <div className='form-text mt-2'>
        Selecciona un rol del dropdown para agregarlo. Los roles seleccionados aparecerán arriba.
      </div>
    </div>
  )
}

export default RolesSelector
